import settings from "../../config";
import Button from "../Button";

const Download = () => {

  return (
    <div className="flex items-center justify-center h-full">
      <Button className="w-1/2" small text="Download" action={() => {
        window.open(`${settings.api}admin/db`, "_blank");
      }}>Download</Button>
    </div>
  );
};

export default Download;
